export default {
  loadingMounted (state) {
    return state.loadingMounted
  }
}



// WEBPACK FOOTER //
// ./src/store/shared/getters.js